<script>
import { cdmFieldsMethods } from '@state/helpers'
import _ from 'lodash'

export default {
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      ...this.field,
      selectItems: [
        { text: 'Please select one', disabled: true },
        { text: 'String', value: 0 },
        { text: 'Decimal', value: 1 },
        { text: 'Date', value: 2 },
      ],
    }
  },
  computed: {
    placeholders() {
      return {
        caption: 'Caption',
        format: 'Data Format',
      }
    },
  },
  created() {
    this.originalField = {
      uniqueIdentifier: this.field.uniqueIdentifier,
      revenueCode: this.field.revenueCode,
      modifier: this.field.modifier,
      caption: this.field.caption,
      showInTable: this.field.showInTable,
      includeInCdmr: this.field.includeInCdmr,
      procedureCode: this.field.procedureCode,
      activeInactive: this.field.activeInactive,
      type: this.field.type,
      format: this.field.format,
      order: this.field.order,
    }

    this.tryUpdateField = _.debounce(this.tryUpdateField, 500)
  },
  methods: {
    ...cdmFieldsMethods,
    tryUpdateField() {
      var vm = this
      var toUpdate = this.field
      toUpdate.uniqueIdentifier = this.uniqueIdentifier
      toUpdate.caption = this.caption
      toUpdate.showInTable = this.showInTable
      toUpdate.revenueCode = this.revenueCode
      toUpdate.modifier = this.modifier
      toUpdate.includeInCdmr = this.includeInCdmr
      toUpdate.procedureCode = this.procedureCode
      toUpdate.activeInactive = this.activeInactive
      toUpdate.type = this.type
      toUpdate.format = this.format
      toUpdate.order = this.order
      return this.updateField(toUpdate)
        .then(updated => {
          vm.uniqueIdentifier = updated.uniqueIdentifier
          vm.caption = updated.caption
          vm.showInTable = updated.showInTable
          vm.includeInCdmr = updated.includeInCdmr
          vm.procedureCode = updated.procedureCode
          vm.revenueCode = updated.revenueCode
          vm.activeInactive = updated.activeInactive
          vm.modifier = updated.modifier
          vm.type = updated.type
          vm.format = updated.format
          vm.order = updated.order

          vm.originalField = updated
        })
        .catch(error => {
          this.updateError = error

          vm.uniqueIdentifier = vm.originalField.uniqueIdentifier
          vm.caption = vm.originalField.caption
          vm.showInTable = vm.originalField.showInTable
          vm.includeInCdmr = vm.originalField.includeInCdmr
          vm.procedureCode = vm.originalField.procedureCode
          vm.revenueCode = vm.originalField.revenueCode
          vm.modifier = vm.originalField.modifier
          vm.activeInactive = vm.originalField.activeInactive
          vm.type = vm.originalField.type
          vm.format = vm.originalField.format
          vm.order = vm.originalField.order
        })
    },
    updateUniqueIdentifier(checked) {
      this.uniqueIdentifier = checked
      return this.tryUpdateField()
    },
    updateRevenueCode(checked) {
      this.revenueCode = checked
      return this.tryUpdateField()
    },
    updateModifier(checked) {
      this.modifier = checked
      return this.tryUpdateField()
    },
    updateShowInTable(checked) {
      this.showInTable = checked
      return this.tryUpdateField()
    },
    updateIncludeInCdmr(checked) {
      this.includeInCdmr = checked
      return this.tryUpdateField()
    },
    updateProcedureCode(checked) {
      this.procedureCode = checked
      return this.tryUpdateField()
    },
    updateActiveInactive(checked) {
      this.activeInactive = checked
      return this.tryUpdateField()
    },
    updateType(value) {
      this.type = value
      return this.tryUpdateField()
    },
  },
}

/*
    {
      uniqueIdentifier: true,
      name: 'Test',
      caption: 'Test Caption',
      showInTable: true,
      includeInCdmr: true,
      procedureCode: false,
      type: 0,
      format: null,
      order: 0,
      organizationId: 'c1ef359f-6bd0-4d12-8a3d-1522788ea43e',
      organization: null,
      id: '97b7bc83-e013-4041-8f16-3fb56989928d',
      stringId: '97b7bc83-e013-4041-8f16-3fb56989928d',
    }
*/
</script>

<template>
  <tr>
    <td colspan="1" :class="$style.drag">
      <v-icon>mdi-drag</v-icon>
    </td>
    <td colspan="2">{{ name }}</td>
    <td colspan="2">
      <v-text-field
        v-model="caption"
        color="cyan"
        :placeholder="placeholders.caption"
        @input="tryUpdateField"
      />
    </td>
    <td colspan="1">
      <v-checkbox
        v-model="uniqueIdentifier"
        type="checkbox"
        color="cyan"
        @change="updateUniqueIdentifier"
      />
    </td>
    <td colspan="1">
      <v-checkbox
        v-model="activeInactive"
        type="checkbox"
        color="cyan"
        @change="updateActiveInactive"
      />
    </td>
    <td colspan="1">
      <v-checkbox
        v-model="showInTable"
        type="checkbox"
        color="cyan"
        @change="updateShowInTable"
      />
    </td>
    <td colspan="1">
      <v-checkbox
        v-model="includeInCdmr"
        type="checkbox"
        color="cyan"
        @change="updateIncludeInCdmr"
      />
    </td>
    <td colspan="1">
      <v-checkbox
        v-model="procedureCode"
        type="checkbox"
        color="cyan"
        @change="updateProcedureCode"
      />
    </td>
    <td colspan="1">
      <v-checkbox
        v-model="modifier"
        type="checkbox"
        color="cyan"
        @change="updateModifier"
      />
    </td>
    <td colspan="1">
      <v-checkbox
        v-model="revenueCode"
        type="checkbox"
        color="cyan"
        @change="updateRevenueCode"
      />
    </td>
    <td colspan="2">
      <v-select
        v-model="type"
        color="cyan"
        :items="selectItems"
        @input="updateType"
      ></v-select>
    </td>
    <td colspan="2">
      <v-text-field
        v-model="format"
        color="cyan"
        :placeholder="placeholders.format"
        @input="tryUpdateField"
      />
    </td>
  </tr>
</template>

<style lang="scss" module>
@import '@design';

.drag {
  cursor: move;
}
</style>
